module.exports = __webpack_public_path__ + "81319cbe264e03d4f7ed6e5d11fc1401.svg";